export default function Hero() {
  return (
    <section id="top" className="pt-24 md:pt-32">
      <div className="w-full px-4 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div className="anim-fade-up">
            <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100 text-secondary-900 text-xs font-label">
              <span className="w-1.5 h-1.5 rounded-full bg-primary-500 anim-pulse-dot" />
              今日风向 · 实时更新
            </span>

            <h1 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-snug md:leading-tight mt-6">
              吃瓜之前，
              <br />
              先看清<span className="text-primary-600">网友站队</span>再开口
            </h1>

            <p className="mt-6 text-base md:text-lg text-foreground-600 leading-relaxed max-w-xl">
              这里不爆料、不替谁定性。黑料热点把热传事件的网友评论、站队情况与争议焦点摆在一处，实时展示舆论反转、态度变化与公关动作，帮你判断风向，再决定要不要站队。
            </p>

            <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 mt-9 max-w-md">
              <a
                href="#flash"
                className="inline-flex items-center justify-center gap-2 h-12 px-7 rounded-md bg-primary-500 text-background-50 text-sm font-label hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-flashlight-line text-base" />
                看今日快讯流
              </a>
              <a
                href="#stance"
                className="inline-flex items-center justify-center gap-2 h-12 px-7 rounded-md border border-background-300/80 text-foreground-800 text-sm font-label hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-group-line text-base" />
                查站队情况
              </a>
            </div>

            <div className="flex flex-wrap items-center gap-x-8 gap-y-3 mt-10">
              <div className="flex flex-col">
                <span className="font-heading text-2xl font-bold text-foreground-950">12,480</span>
                <span className="text-xs text-foreground-500 font-label mt-1">今日表态人数</span>
              </div>
              <div className="w-px h-10 bg-background-300/70 hidden sm:block" />
              <div className="flex flex-col">
                <span className="font-heading text-2xl font-bold text-foreground-950">4</span>
                <span className="text-xs text-foreground-500 font-label mt-1">跟踪中热点</span>
              </div>
              <div className="w-px h-10 bg-background-300/70 hidden sm:block" />
              <div className="flex flex-col">
                <span className="font-heading text-2xl font-bold text-foreground-950">2</span>
                <span className="text-xs text-foreground-500 font-label mt-1">今日发生反转</span>
              </div>
            </div>
          </div>

          <div className="anim-fade-up relative">
            <div className="w-full h-[340px] sm:h-[440px] lg:h-[520px] rounded-lg overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20editorial%20collage%20of%20layered%20warm%20cream%20and%20terracotta%20paper%20textures%20with%20soft%20shadows%20and%20subtle%20grain%2C%20minimal%20magazine%20cover%20aesthetic%2C%20calm%20negative%20space%2C%20artistic%20composition%2C%20no%20text&width=900&height=1100&seq=heiliaoredian-hero-01&orientation=portrait"
                alt="黑料热点 舆论风向 抽象杂志插画"
                title="黑料热点舆论风向插画"
                className="w-full h-full object-top"
              />
            </div>

            <div className="absolute -bottom-6 left-4 sm:left-6 right-4 sm:right-auto sm:w-[300px] bg-background-50 border border-background-200/80 rounded-lg p-4">
              <div className="flex items-center gap-2">
                <i className="ri-arrow-left-right-line text-primary-500" />
                <span className="font-label text-xs text-foreground-500">今日最大反转</span>
              </div>
              <p className="font-heading text-base font-semibold text-foreground-950 mt-2 leading-snug">
                「剧集替身」爆料被原作者否认
              </p>
              <p className="text-xs text-foreground-500 mt-2 leading-relaxed">
                质疑声 -14%　中立声 +9%　态度分析已更新
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}